import React from "react";
import { Send } from "lucide-react";

const InputArea = ({ value, setValue, loading, onSend, onKeyDown }) => {
  return (
    <div className="border-t border-slate-200 dark:border-slate-800 bg-white/70 dark:bg-slate-950/40 backdrop-blur px-3 sm:px-5 py-3">
      <div className="flex items-end gap-2">
        <textarea
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={onKeyDown}
          rows={1}
          placeholder="پیام خود را بنویسید…"
          className="
            flex-1 resize-none rounded-3xl border border-slate-200 dark:border-slate-800
            bg-white dark:bg-slate-950 px-4 py-3 text-sm text-slate-900 dark:text-slate-100
            outline-none focus:ring-4 focus:ring-blue-100 dark:focus:ring-blue-900/30
            min-h-[48px] max-h-40
          "
        />

        <button
          type="button"
          onClick={onSend}
          disabled={loading || !value.trim()}
          className="
            inline-flex items-center justify-center h-12 w-12 rounded-3xl
            bg-blue-600 text-white hover:bg-blue-700 transition
            disabled:bg-slate-200 disabled:text-slate-500 disabled:cursor-not-allowed
          "
          aria-label="ارسال"
        >
          <Send className="w-5 h-5" />
        </button>
      </div>

      <div className="mt-2 text-[11px] text-slate-500 dark:text-slate-400 text-right">
        Enter برای ارسال، Shift+Enter برای خط جدید
      </div>
    </div>
  );
};

export default InputArea;
